import { useTranslation } from "react-i18next";
import {
  ContentHeader,
  FullWidthSpace,
  MainContentArea,
  ValueOrFallback,
} from "melco-ui";
import { HeaderButtonArea } from "melco-shared-logic";
import { useMachineStatusView } from "../../hooks/reporting/useMachineStatusView";
import { MachineStatusViewMoreActionButton } from "../../components/reporting/machineStatus/MachineStatusViewMoreActionButton";
import { StatusViewDetailForm } from "../../components/reporting/machineStatus/MachineStatusViewDetailForm";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import LoadingDefaultSpinIndicator from "../../components/loading/LoadingDefaultSpinIndicator";

type ViewDetailsProps = {
  viewId: string;
};

export const ViewDetails: React.FC<ViewDetailsProps> = ({ viewId }) => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("reporting", "reportingMachineStatus");
  // const { viewId } = useParams<{
  //   viewId: string;
  // }>();

  const { data: view, isLoading, refetch } = useMachineStatusView(viewId);
  const { name } = view || {};
  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <ValueOrFallback
              value={name ?? ""}
              fallback={t("global.fallback.empty")}
            />
          }
          breadcrumb={breadcrumb}
          extra={
            <>
              <HeaderButtonArea />
              {view && <MachineStatusViewMoreActionButton view={view} />}
            </>
          }
        />
      }
      contentPadding
    >
      <FullWidthSpace direction="vertical" size="large">
        <LoadingDefaultSpinIndicator isShown={isLoading}>
          <StatusViewDetailForm machineStatusView={view} refetch={refetch} />
        </LoadingDefaultSpinIndicator>
      </FullWidthSpace>
    </MainContentArea>
  );
};
